



















import Vue from 'vue';
import Component from 'vue-class-component';
import ToolBar from '@/components/ToolBar.vue';
import HomeCard from '@/components/HomeCard.vue';

Vue.component('tool-bar', ToolBar);
Vue.component('home-card', HomeCard);

@Component({
  components: {
    ToolBar,
    HomeCard,
  },
})
export default class Home extends Vue {
  private cameraCardInfo: object = {
    icon: 'camera_alt',
    iconColor: '#5fad46',
    targetBlank: false,
    path: '/camera',
    content: 'Para acessar a câmera da aplicação, que é usada para fazer \
     o reconhecimento dos marcadores, clique aqui.',
  };
  private driveCardInfo: object = {
    icon: 'cloud_download',
    iconColor: '#448aff',
    targetBlank: true,
    path: 'https://drive.google.com/open?id=1Aa5jXFIh4385wKT36mFFP82zho7BmfBP',
    content: 'O reconhecimento das letras é feito por meio de marcadores, \
      que estão armazenados no Google Drive. Clique aqui para baixá-los.',
  };
  private wikiCardInfo: object = {
    icon: 'help',
    iconColor: '#f15a22',
    targetBlank: true,
    path: 'https://jlucassr.github.io/ArBC-Pages/',
    content: 'Para acessar a wiki do projeto, que contém diversas \
      informações adicionais sobre o software, clique aqui.',
  };
}
